module.exports = __webpack_public_path__ + "img/insights-logo.c96c9b06.png";